// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2sLPb","title":"BackImages_title__2XT7j","images":"BackImages_images__2YeEJ"};